import Result from './result.riot';
import { connect } from '@/common/lib/riot-redux';
export default connect(Result, state => ({ result: state.result }));